import type React from "react";
import { getColor, type Props } from "~/components/icons/helper";

export const OpenNewTabIcon: React.FC<Props> = ({ color }) => {
	const stroke = getColor(color);
	return (
		<svg
			role="img"
			aria-label="Open New Tab"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M15 7V13C15 14.1046 14.1046 15 13 15H3C1.89543 15 1 14.1046 1 13V3C1 1.89543 1.89543 1 3 1H9"
				stroke="white"
				strokeLinecap="round"
			/>
			<path d="M4.99976 11L14.9998 1" stroke={stroke} strokeLinecap="round" />
			<path d="M14.9998 4V1H11.9998" stroke={stroke} strokeLinecap="round" />
		</svg>
	);
};
